import React from 'react';

const Placeholder = (
  {
    className,
    tag = 'div',
    width= '100%',
    maxWidth= '120px',
    height= 'auto',
    margin = '0 0 10px 0',
    backgroundColor = 'var(--cosmos-color-surface-glass-light-20)',
    borderRadius = '1.5px',
    style = {}
  }) => {
  const CustomTag = `${tag}`;
  return (
      <CustomTag
        className={className}
        style={{
          ...style,
          width: width,
          maxWidth: maxWidth,
          height: height,
          margin: margin,
          backgroundColor: backgroundColor,
          borderRadius: borderRadius
        }}>
        &nbsp;
      </CustomTag>
  )
}

export { Placeholder };
